import { Box } from '@mui/material';
import { type ReactNode } from 'react';

interface HumanTaskIndentContainerProps {
  children: ReactNode;
}

export function HumanTaskIndentContainer(props: HumanTaskIndentContainerProps) {
  const { children } = props;
  return (
    <Box
      sx={{
        borderLeft: '4px solid',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        paddingLeft: 3,
      }}
    >
      {children}
    </Box>
  );
}
